import { render, staticRenderFns } from "./onlyLoginLayout.vue?vue&type=template&id=05fbd560&scoped=true&"
import script from "./onlyLoginLayout.vue?vue&type=script&lang=js&"
export * from "./onlyLoginLayout.vue?vue&type=script&lang=js&"
import style0 from "./onlyLoginLayout.vue?vue&type=style&index=0&id=05fbd560&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fbd560",
  null
  
)

export default component.exports